import PortalIdParser from 'PortalIdParser';
export const getRecordHref = (objectTypeId, objectId) => {
  return `/contacts/${PortalIdParser.get()}/record/${encodeURIComponent(objectTypeId)}/${encodeURIComponent(objectId)}`;
};